import React from 'react';
import { useTranslation } from 'react-i18next';

import AddIcon from '@mui/icons-material/Add';
import { SxProps, Theme } from '@mui/material';

import { AddFileButtonTitle, AddFileButtonWrap } from './style';

interface PropsType extends React.HTMLAttributes<HTMLDivElement> {
	sx?: SxProps<Theme>;
}

function AddFileButton({ sx, ...props }: PropsType) {
	const { t } = useTranslation();
	return (
		<AddFileButtonWrap sx={sx} {...props}>
			<AddIcon sx={{ fontSize: '16px' }} color="primary" />
			<AddFileButtonTitle variant="subtitle1">{t('shared.addFile')}</AddFileButtonTitle>
		</AddFileButtonWrap>
	);
}

export default AddFileButton;
